module.exports = __webpack_public_path__ + "img/succubus_small.6f6d53df.png";